import PropTypes from "prop-types";
import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
  button: {
    borderRadius: "50px",
    border: "1px solid black",
    fontWeight: "bold",
    textTransform: "initial",
    fontSize: "16px",
    padding: theme.spacing(0, 4),
  },
}));

function RefrezhButton({
  onClick,
  children,
  className = "",
  disabled = false,
  style = {},
}) {
  const classes = useStyles();

  return (
    <Button
      className={clsx(classes.button, className)}
      variant="outlined"
      disabled={disabled}
      onClick={onClick}
      onTouchEnd={onClick}
      style={style}
    >
      {children}
    </Button>
  );
}

RefrezhButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.any,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  style: PropTypes.object,
};

export default RefrezhButton;
